var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5vw",
    height: "5vw",
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#F4F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 30V26C47 25.7348 46.8946 25.4804 46.7071 25.2929C46.5196 25.1054 46.2652 25 46 25H26C25.7348 25 25.4804 25.1054 25.2929 25.2929C25.1054 25.4804 25 25.7348 25 26V30H47Z",
    fill: "#2EC5CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 32V46C25 46.2652 25.1054 46.5196 25.2929 46.7071C25.4804 46.8946 25.7348 47 26 47H31V32H25Z",
    fill: "#B1C7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 47H46C46.2652 47 46.5196 46.8946 46.7071 46.7071C46.8946 46.5196 47 46.2652 47 46V32H33V47Z",
    fill: "#3050F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.6f21bb9d.svg";
export { ForwardRef as ReactComponent };